<template>
    <div class="header_box" :class="{'home-header': true, 'home-header-fixed': show }">
        <div class="wrap" >
  	        <!-- 机构id:2189 -->
            <div class="l icon_l" id="icon_l" style="display:none;"> 
                <!-- <a href="/"></a>  -->
                <!-- <span class="hand">田田阅读</span> -->
            </div>
            <!-- 机构id不等于2189 -->
            <div class="l" id="icon_r" v-if="userInfo.orgId != '3883'"> 
    	        <!-- <a href="javascript:;" router-link :to="{path:'homePage'}"></a>  -->
                <router-link :to="{path:'/home'}" class="tab_color">
                    <h1 class="logo" id="logo"></h1>
                </router-link>
                <!-- <router-link :to="{path:'/home'}" class="tab_color">
                    <span class="hand">田田阅读</span> 
                </router-link> -->
            </div>
            <div class="r">
                <ul id="tit">
                    <li id="myBook">
                        <router-link :to="{name:'personalDesktop', params:{id:0}}" class="tab_color">
                            个人桌面
                        </router-link>
                    </li>
                    <!-- <li id="myBook" v-if="config.length > 0 ? (config[0].type == 1 && config[0].enableStatus == 1) : false">
                        <router-link :to="{name:'myOrder'}" class="tab_color">
                            我的订购
                        </router-link>
                    </li>
                    <li id="myBook" v-if="config.length > 0 ? (config[15].type == 16 && config[15].enableStatus == 1) : false">
                        <router-link :to="{name:'myBorrow'}" class="tab_color">
                            我的借阅
                        </router-link>
                    </li>
                    <li id="myBook" v-if="config.length > 0 ? (config[2].type == 3 && config[2].enableStatus == 1) : false">
                        <router-link :to="{name:'shelfTypeList'}" class="tab_color">
                            我的书架
                        </router-link>
                    </li> -->
                    <!-- <li class="setColor" v-if="config.length > 0 ? (config[9].type == 10 && config[9].enableStatus == 1) : false">
                        <span>换肤</span>
                        <div class="setStylelist">
                            <span :class="item.cssName" @click="changeTheme(item)" v-for="(item, index) in themeType" :key="index">{{ item.title }}</span>
                        </div>
                    </li> -->
                    <li class="setColor" v-if="config.length > 0 ? (config[31].type == 32 && config[31].enableStatus == 1) : false" @click="setThemeBg()">
                        <span>背景设置</span>
                    </li>
                    <li id="loginInformation" v-if="denglu">
                        <a href="javascript:;">                            
                            <i class="change_color">{{ orgName }}</i>
                            您好，欢迎访问
                        </a>
                    </li>
                    <!-- <li id="loginInformation" v-if="denglu"><a href="javascript:;" id="login" @click="itemClick">登录</a></li> -->
                    <li class="select" style="height: 48px;line-height: 48px;">
                        <!-- <a class="change_color" id="change" slot="reference">
                            <em>
                                <img src="../assets/images/noheader_pic.png" alt="" >
                            </em>
                        </a> -->
                        <!-- <el-collapse-transition>
                            <p  id="zhanghao" v-show="show3"> 
                                <a class="wire" href="/pcdesktop/index.html?openType=account">账号设置</a>
                                <a href="javascript:;" id="jsScExit" @click="TuiClick">退出账号</a>
                            </p>
                        </el-collapse-transition> -->
                        <el-popover
                            placement="top-start"
                            trigger="click"
                            width="50"
                            padding="0"
                            >
                            <a class="change_color" id="change" slot="reference">
                                <em>
                                    <img src="../assets/images/noheader_pic.jpg" alt="" >
                                </em>
                            </a>
                            <i class="popup1" style="display: flex;flex-direction: column;text-align: center;font-size: 16px">
                                <a @click="TuiClick" style="text-decoration: none;">退出登录</a>
                                <i class="jt"></i>
                            </i>
                        </el-popover>
                    </li>
                    <li id="pcdesktop" style="display:none"><a href="javascript:;">个人桌面</a></li>
                    <li id="ttManage" style="display:none"><a href="/libmanage/index.html">管理后台</a></li>
                    <!-- li><a href="/ttweb/html/app/app.html" target="_blank">APP下载</a></li-->
                </ul>
            </div>
            <div class="clear"></div>
        </div>
    </div>     
</template>

<script>
// import { getUserInfo, removeItem } from "@/common/utils/localStorage.js";
import Axios from "@/api/diyaxios";
import { env, plat, orgCustoms} from '../dataJson/custom'
import { getUserInfo, getItem, setItem } from "@/common/utils/localStorage.js";
import { setConfig, logout } from "@/api/user.js";
import popup from "../common/plugin/dialog/index";
import themebgList from "./themeBgList.vue";
export default {
    inject:['reload'],
    name: "Header",
    data() {
        return {
            config:[],
            themeType: [
                {title:'默认', cssName:'default'},
                {title:'喜悦', cssName:'hot'},
                {title:'清新', cssName:'green'},
                {title:'时尚', cssName:'fashion'},
                {title:'科技', cssName:'tech'}
            ],
            userInfo: getUserInfo(),
            shopCarNum: 0,
            levelList: [],
            isCollapse:false,
            denglu: true,//登录文字显示隐藏
            shezhi: false,
            activeName: "first",
            logining: false,
            loginform: {
                user: "",
                password: "",
            },
            registerform: {
                user: "",
                password: "",
            },

            // 表单验证，需要在 el-form-item 元素中增加 prop 属性
            rules: {
                user: [
                    {
                        required: true,
                        message: "账号不可为空",
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "密码不可为空",
                        trigger: "blur",
                    },
                ],
            },
            show: false,
            show3: false,
            user: false
        };
    },
    computed: {
        orgName() {
            return getUserInfo().realName;
        },
    },
    components: {},
    watch: {
        $route() {
            this.getBreadcrumb();
        },
        orgName() {
            return getUserInfo().realName;
        },
    },
    created() {
        let vm = this;
        if(getUserInfo().orgId == '3883'){
            document.title = '江汉区图书馆';
        }
        if(Object.keys(vm.userInfo).length === 0) {
            setItem('remindLink', window.location.hash);           
            if(vm.$route.query.dircode){
                setItem('pkid', vm.$route.query.pkid); 
                setItem('source', vm.$route.query.source); 
                setItem('dircode', vm.$route.query.dircode);      
                // vm.$router.push({path:'/', params:{dircode: 'y7otn5Uv'}});
                vm.$router.push({name:"Login", params:{dircode: vm.$route.query.dircode}});
            } else{                
                vm.$router.push({name:"Login"});
            }
        }else{
            // vm.getSetConfig();
            vm.config = JSON.parse(getItem('config'));
            if(getItem('theme')){
                window.document.documentElement.setAttribute('data-theme', getItem('theme'));
            }
        }
    },
    mounted() {
        let userInfo = getUserInfo();
        window.addEventListener("scroll", this.showSearch)
        // if(getUserInfo().denglu) {
        //     this.denglu = true;
        // } else {
        //     this.denglu = true;
        // }
        // if(userInfo.token == null) {
        //     this.$router.push({name:"Login"})
        // }
    },
    methods: {
        //设置背景图
        setThemeBg(){
            let vm = this;           
            vm.themebg_list = popup('<themebg-list @close="close" @submit="submit" />',{
                option:{
                    title:'设置主题背景',
                    width:'900px'
                },
                popup:{
                    data(){
                        return{
                            
                        }
                    },
                    components:{
                        themebgList
                    },
                    methods:{
                        close(){
                            vm.themebg_list.hide();
                        },
                        submit(){
                            vm.$emit('settheme');
                        },
                    }
                }
            });
            vm.themebg_list.show();
        },
        //获取权限显示
        getSetConfig(){
            let vm = this,
                obj = {
                    // orgId: getUserInfo().orgId,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: "",
                };
            setConfig(obj).then(res => {
                if(res.status){
                    // t.config = res.data;
                    let configData = [],
                        list = {};
                    for(var i = 1;i<=40;i++){
                        let list = {type:i, orgId:getUserInfo().orgId, dataStatus:1, enableStatus: 2}; //默认不显示
                        res.data.map((item, index) =>{
                            if(item.type == i){
                                // list.pkid = item.pkid;
                                list.enableStatus = item.enableStatus;
                                return true;
                            }
                        });
                        configData.push(list);
                    }
                    t.config = configData;
                    setItem('config', JSON.stringify(configData));
                }
            }).catch(err => {

            });
        },
        //切换主题
        changeTheme(data){
            let t = this;
            //js具体判断使用哪个主题
            window.document.documentElement.setAttribute('data-theme', data.cssName);
            setItem('theme', data.cssName);
        },
        // openInfo() {
        //     this.user = !true
        // },
        showSearch() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop  > 0) {   // 当页面滚动到高度300px处，动态绑定class 来设置头部固定定位
              this.show = true;
            }else {
              this.show = false;
            }
        },
        //登录显示隐藏
        itemClick(){
            this.$bus.$emit('login','true')
        },
        TuiClick() {
            let vm = this;
            vm.$confirm('您确定退出吗？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(localStorage.getItem('sessionId')){
                    // Axios.get('/auth/ttv3/security/core/wxqrcode/logout',{
                    Axios.get(env+'/ttv3/security/core/wxqrcode/logout',{
                        params: {
                            sessionId: localStorage.getItem("sessionId")
                        }
                    }).then(res => {
                        // res: logout-suc
                            localStorage.removeItem("sessionId");
                        
                    }).catch(err => {
                        
                    });
                }
                //退出
                logout({
                    token:localStorage.getItem("token"),
                    loginRedisKey:localStorage.getItem("authKey"),
                    deviceType: 1,//1:pc， 2：H5  3：小程序
                    visitFunc: "",
                    visitType: 2,
                    visitUrl: location.href
                }).then(res => {
                    if(res.status){                        
                        localStorage.removeItem("userInfo");
                        localStorage.removeItem("orgId");
                        localStorage.removeItem("userId");
                        localStorage.removeItem("token");
                        localStorage.removeItem("sign");
                        localStorage.removeItem("authKey");
                        localStorage.removeItem("account");
                        localStorage.removeItem("demoSignal");
                        localStorage.removeItem("config");
                        localStorage.removeItem("remindLink");
                        localStorage.removeItem("dircode");
                        localStorage.removeItem("pkid");
                        localStorage.removeItem("source");
                        this.denglu = false;
                        if(plat == 4){ //鄂州职业大学图书馆 ，域名部署。 退出后，统一身份认证
                            // window.location.href = 'https://read.ezu.cn/readermain/ttv3/security/core/cas/logout?deviceType=1'; //鄂州职业大学域名;
                            window.location.href = 'http://172.19.40.3/readermain/ttv3/security/core/cas/logout?deviceType=1'; //鄂州职业大学域名;
                        }else{
                            this.$router.push({name:"Login"});
                        }
                    }else{                        
                        vm.$message({
                            message: "退出失败！",
                            type: "error"
                        });
                    }
                }).catch(err=>{

                });
            }).catch(() => {

            });
        },
    },
};
</script>

<style scoped lang="scss">

// .login-title {
//     text-align: center;
//     margin: 0 auto 40px auto;
//     color: #303133;
// }
// .register-title {
//     text-align: center;
//     margin: 0 auto 40px auto;
//     color: #303133;
// }
.home-header-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #191919;
    color: fff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    padding: 0;
    .home-picture,
    .home-hot {
      display: none;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Header.vue